export default __webpack_public_path__ + "static/media/status_available.35f9aa36.svg";